// extracted by mini-css-extract-plugin
export default {"wrapper":"PowerOutageAlarmAnalysis_wrapper__0Ho3Q","twoLineText":"PowerOutageAlarmAnalysis_twoLineText__jRU9K"};